import { array, string } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { DropdownItem } from '@optimus-web/core';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useRepositoryQuery } from '@mews-commander/data-access';

export const useCashiersOptions = (defaultValue: Array<string>) => {
    const enterpriseId = useCurrentEnterpriseId();

    const { data, isLoading } = useRepositoryQuery('cashiers', 'getCentral', { enterpriseId });

    const options =
        pipe([...(data?.externalIdentifiers || []), ...defaultValue], array.uniq(string.Eq)).map((id) => (
            <DropdownItem key={id} value={id} label={id} />
        )) || [];

    return {
        options,
        isLoading,
    };
};
